import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { LinkColor } from '@freelancer/ui/link';
import { Margin } from '@freelancer/ui/margin';

interface NavigationMenuListItem {
  linkDescription: string;
  linkUrl: string;
}

@Component({
  selector: 'app-navigation-menu-list',
  template: `
    <div class="LinksColumn">
      <fl-link
        *ngFor="let item of list; trackBy: trackByLinkUrl"
        flTrackingLabel="SkillLink"
        [flMarginBottom]="'small'"
        [flMarginBottomTablet]="marginBottomTablet"
        [link]="item.linkUrl"
        [color]="listColor"
        [newTab]="false"
      >
        {{ item.linkDescription }}
      </fl-link>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./navigation-menu-list.component.scss'],
})
export class NavigationMenuListComponent {
  @Input() listColor = LinkColor.LIGHT;
  @Input() marginBottomTablet?: Margin;
  @Input() list: readonly NavigationMenuListItem[] = [];

  trackByLinkUrl(_: number, item: NavigationMenuListItem): string {
    return item.linkUrl;
  }
}
